var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeMobileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 80,
    viewBox: "0 0 50 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-mobile-alt",
    "data-name": "Icon awesome-mobile-alt",
    d: "M42.5,0H7.5A7.5,7.5,0,0,0,0,7.5v65A7.5,7.5,0,0,0,7.5,80h35A7.5,7.5,0,0,0,50,72.5V7.5A7.5,7.5,0,0,0,42.5,0ZM25,75a5,5,0,1,1,5-5A4.995,4.995,0,0,1,25,75ZM42.5,58.125A1.881,1.881,0,0,1,40.625,60H9.375A1.881,1.881,0,0,1,7.5,58.125V9.375A1.881,1.881,0,0,1,9.375,7.5h31.25A1.881,1.881,0,0,1,42.5,9.375Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeMobileAlt);
export default __webpack_public_path__ + "static/media/Icon awesome-mobile-alt.3aff6406b5a642137ad995eccfde406a.svg";
export { ForwardRef as ReactComponent };